import React from 'react';

import { useRouter } from 'next/router';

import Competitions from '@components/lpc/Competitions/Competitions';
import Layout from '@components/lpc/Layout/Layout';
import { contestType } from '@propTypes/potTypes';
import AlertsService from '@services/domain/Lpc/AlertsService';
import AuthService from '@services/domain/Lpc/AuthService';
import { getFullRoute } from '@services/http/Route';
import StringService, { htmlToText } from '@services/utils/StringService';

import Custom404 from '../../404';
import Custom500 from '../../500';

type CompetitionsGamePageProps = {
    userAccount: any;
    contest: contestType;
    showAdminBanner: boolean;
    error: any;
};

const CompetitionsGamePage = ({ userAccount, contest, showAdminBanner, error }: CompetitionsGamePageProps) => {
    const router = useRouter();

    if (error.status == 404 || error.status == 401) {
        return <Custom404 />;
    }

    if (error.status == 500) {
        return <Custom500 />;
    }

    return (
        <>
            <Layout
                hideFooter
                ogDescription={htmlToText(contest.pageWording)}
                ogTitle={contest.pageTitle}
                ogUrl={StringService.getUrlWithoutParams(getFullRoute(router.asPath))}
                ogImage={process.env.NEXT_PUBLIC_BACKEND_URL + contest.pageImgUrl}
            >
                <Competitions contest={contest} userAccount={userAccount} showAdminBanner={showAdminBanner} />
            </Layout>
        </>
    );
};

export default CompetitionsGamePage;

export const getServerSideProps = async (ctx) => {
    const userAccount = await AuthService.getUser(ctx);
    let contest: contestType;
    let showAdminBanner: boolean = false;
    let error: any;

    await AlertsService.getCompetitionGame(ctx.query.uniq, ctx)
        .then((res) => {
            if (!res.data.activated) {
                showAdminBanner = true;
            }
            contest = res.data;
        })
        .catch((err) => {
            error = err;
        });

    return {
        props: {
            userAccount: userAccount || {},
            contest: contest || {},
            error: error || {},
            showAdminBanner: showAdminBanner || false,
        },
    };
};
